
$("[data-reschedule]").click(function (e) {
    e.preventDefault();
    var data = $(this).data();
    var modal_size = "sm";
    var modal = "#modal_" + modal_size;
    var modal_title = $(".modal_title_" + modal_size);
    var modal_content = $(".modal_content_" + modal_size);

    $.ajax({
        url: data.reschedule,
        type: "POST",
        dataType: "json",
        beforeSend: () => {
            loaderShow();
        },
        success: (response) => {

            if (response.message) {
                loaderClose();
                modal_title.html("Ops!");
                modal_content.html(response.message);
                openModal(modal);
            }
            if (response.redirect) {
                setTimeout(() => {
                    window.location.href = response.redirect;
                }, 400);
            }

        },
        error: () => {
            var message = "<div class='message error icon-warning'>Desculpe mas não foi possível processar a requisição. Favor tente novamente!</div>";

            setTimeout(function () {
                modal_title.html("Ops!");
                modal_content.html(message);
                openModal(modal);
            }, 400);

            loaderClose();
        }
    });
});


// COUPON
$("#form_reschedule_coupon").submit(function (e) {
    e.preventDefault();
    var form = $(this);
    var modal_size = "sm"
    var modal = "#modal_" + modal_size;
    var modal_title = $(".modal_title_" + modal_size);
    var modal_content = $(".modal_content_" + modal_size);

    form.ajaxSubmit({
        url: form.attr('action'),
        type: 'POST',
        dataType: 'json',
        beforeSend: () => {
            loaderShow();
        },
        success: (response) => {
            //message
            if (response.message) {
                setTimeout(() => {
                    modal_title.html('');
                    modal_content.html(response.message);
                    openModal(modal);
                }, 400);
            }
            //reload
            if (response.reload) {
                window.location.reload();
            }
        },
        complete: () => {
            setTimeout(() => {
                loaderClose();
            }, 600);
        }
    });
});